export default {
    // 查询扩展组
    queryLabelGroup(params, response) {
        window.vue.$apiAxios.postRequestBody('/workFlowLabelGroup/queryLabelGroup', params, response);
    },
    // 新增扩展组
    addLabelGroup(params, response) {
        window.vue.$apiAxios.postRequestBody('/workFlowLabelGroup/addLabelGroup', params, response);
    },
    // 编辑扩展组
    updateLabelGroup(params, response) {
        window.vue.$apiAxios.postRequestBody('/workFlowLabelGroup/updateLabelGroup', params, response);
    },
    // 删除扩展组
    deleteLabelGroup(params, response) {
        window.vue.$apiAxios.postRequestBody('/workFlowLabelGroup/deleteLabelGroup', params, response);
    },
    // 查询扩展组元素
    queryLabelList(params, response) {
        window.vue.$apiAxios.postRequestBody('/workFlowLabel/queryLabelList', params, response);
    },
    // 新增扩展组元素
    addLabel(params, response) {
        window.vue.$apiAxios.postRequestBody('/workFlowLabel/addLabel', params, response);
    },
    // 编辑扩展组元素
    updateLabel(params, response) {
        window.vue.$apiAxios.postRequestBody('/workFlowLabel/updateLabel', params, response);
    },
    // 删除扩展组元素
    deleteLabel(params, response) {
        window.vue.$apiAxios.postRequestBody('/workFlowLabel/deleteLabel', params, response);
    }
};